import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
 
import {appApiResources} from '../../../configuration/app.constants';

@Injectable({
  providedIn: 'root'
})
export class DownloadDonationService {

  constructor(private http: HttpClient) {}

  async download(offering_id,partner_id) {
    try { 
      let response = await this.http
      .get(`${appApiResources.downloadDonation}?offering_id=${offering_id}&partner_id=${partner_id}`)
         .toPromise();
      return response;
    } catch (error) { 
      return error;
    }
  }
}
